import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TextService } from 'src/app/core/service/text.service';

@Component({
  selector: 'app-base-chart',
  templateUrl: './base-chart.component.html',
  styleUrls: ['./base-chart.component.scss'],
})
export class BaseChartComponent implements OnInit {
  formGroup: FormGroup;
  data: any;
  chartOptions = [];
  chartType = 'line';
  @ViewChild('chart') chart;
  generalTexts: any = {
    chartOptions: [
      { labelId: 'L_BAR_CHART', type: 'bar' },
      { labelId: 'L_LINE_CHART', type: 'line' },
      { labelId: 'L_PIE_CHART', type: 'pie' },
    ],
  };
  constructor(private textService: TextService) {
    this.formGroup = new FormGroup({
      chartType: new FormControl('', []),
    });
    this.data = {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [
        {
          label: 'My First dataset',
          backgroundColor: '#42A5F5',
          borderColor: '#1E88E5',
          data: [65, 59, 80, 81, 56, 55, 40],
        },
        {
          label: 'My Second dataset',
          backgroundColor: '#9CCC65',
          borderColor: '#7CB342',
          data: [28, 48, 40, 19, 86, 27, 90],
        },
      ],
    };
  }

  ngOnInit(): void {
    this.textService.convert(this.generalTexts).subscribe((texts) => {
      this.chartOptions = texts.chartOptions;
      this.formGroup
        .get('chartType')
        .setValue(this.chartOptions[0], { emitEvent: false });
      this.chartType = this.chartOptions[0].type;
      this.attachEventListener();
    });
  }

  attachEventListener() {
    this.formGroup.get('chartType').valueChanges.subscribe((value) => {
      this.chartType = value.type;
      this.chart.type = value.type;
      this.chart.reinit();
    });
  }
}
